import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonDirective, ModalComponent } from '@com-delta-omnichannel/aura';
import { Notification } from './models/notification.interfaces';

@Component({
  selector: 'idp-notification',
  standalone: true,
  imports: [NgIf, ModalComponent, ButtonDirective],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  @Input() content: Notification = {} as Notification;
}
